'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonTransparent = undefined;
var _styledComponents = require('styled-components');
var _styledComponents2 = _interopRequireDefault(_styledComponents);
var _styledSystem = require('styled-system');
var _Button = require('./Button');
var _Button2 = _interopRequireDefault(_Button);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var ButtonTransparent = exports.ButtonTransparent = (0, _styledComponents2["default"])(_Button2["default"])([], function (props) {
  return {
    '&:hover': {
      color: (0, _styledSystem.themeGet)('colors.' + props.color)(props),
      backgroundColor: 'transparent'
    },
    '&:focus': {
      boxShadow: 'inset 0 0 0 2px, 0 0 0 2px'
    },
    '&:active': {
      backgroundColor: 'transparent',
      boxShadow: 'inset 0 0 0 2px, inset 0 0 8px ' + (0, _styledSystem.themeGet)('colors.darken.1')(props)
    }
  };
});
ButtonTransparent.displayName = 'ButtonTransparent';
ButtonTransparent.defaultProps = {
  color: 'inherit',
  bg: 'transparent'
};
exports["default"] = ButtonTransparent;